import { mapGetters, mapActions } from 'vuex'
import section from '@/api/section'
import { getUploadConfig } from '@/utils/upload'
import help from '@/utils/help'
import user from '@/api/user'
import { settingCountry } from '@/api/setting'
import ChangePwd from './changePwd.dialog.vue'
import journal from '@/api/journal'
export default {
  components: { ChangePwd },
  data() {
    return {
      params: {
        icon: '',
        affiliations: [''],
        reviewJournals: [''],
        keywords: [],
      },
      isReviewer: false,
      showClassification: false,
      categoryList: [],
      rules: {},
      countryList: [],
      roles: [],
      journalList: [],
      isVisable: false,
      isCropper: false,
      canWidth: 105,
      canHeight: 130,
      roleArr: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      user: 'getUser',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      country: 'getCountry',
      reviewFrequency: 'getReviewFrequency',
      degree: 'getDegree',
    }),
  },
  watch: {
    user: {
      handler(val) {
        const {
          icon,
          iconName,
          titleCode,
          firstName,
          lastName,
          countryCode,
          city,
          degreeCode,
          categoryIdList,
          affiliation,
          website,
          cv,
          cvName,
          reviewJournal,
          keyword,
          journalIdList,
          reviewFrequency,
          roleList,
          version,
          frequencyCode,
        } = val
        this.roleArr = {}
        if (roleList) {
          roleList.forEach((item) => {
            // if (
            //   ['REVIEWER', 'EDITORIAL_BOARD', 'GUEST_EDITO'].includes(item.type)
            // ) {
            //   this.showClassification = true
            // }
            if (this.roleArr[item.name]) {
              if (item.journal) {
                this.roleArr[item.name].journals.push(item.journal.name)
              }
            } else {
              this.roleArr[item.name] = {
                name: item.name,
                journals: [],
              }
              if (item.journal) {
                this.roleArr[item.name].journals.push(item.journal.name)
              }
            }
            if (item.type === 'REVIEWER') {
              this.isReviewer = true
              this.rules.reviewFrequency = [
                {
                  required: true,
                  message:
                    'Review Frequency' + this.LANGUAGE[this.language].noEmpty,
                },
              ]
              this.rules.journalIdList = [
                {
                  required: true,
                  message:
                    'Journal(s) Would Like to Review' +
                    this.LANGUAGE[this.language].noEmpty,
                },
              ]
              this.rules.rcv = [
                {
                  required: true,
                  message: 'CV' + this.LANGUAGE[this.language].noEmpty,
                },
              ]
            }
          })
        }
        this.params = JSON.parse(
          JSON.stringify({
            icon,
            iconName,
            titleCode,
            firstName,
            lastName,
            countryCode,
            city,
            degreeCode,
            categoryIdList,
            affiliation,
            affiliations: affiliation ? affiliation.split(';') : [''],
            website,
            cv,
            cvName,
            reviewJournal,
            reviewJournals: reviewJournal ? reviewJournal.split(';') : [''],
            keyword,
            keywords: keyword ? keyword.split(';') : [],
            journalIdList,
            reviewFrequency,
            version,
            frequencyCode,
          })
        )
      },
      immediate: true,
    },
  },
  mounted() {
    this.getSection()
    this.getJournal()
    this.getRules()
    this.countrySearch()
  },
  methods: {
    ...mapActions(['updateUser', 'updateLanguage']),
    async getJournal() {
      this.journalList = await journal.allName({ released: true })
      this.journalList.some((item) => {
        if (item.id === this.params.journalId) {
          this.journal = item
          return true
        }
      })
    },
    async getSection() {
      this.categoryList = await section.getAll()
    },
    changePwd() {
      this.isVisable = true
    },
    confirm() {
      this.isVisable = false
    },
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val,
      })
    },
    addMore(key) {
      this.params[key].push('')
    },
    delMore(key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore(key) {
      const arr = []
      this.params[key + 's'].forEach((item) => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
    //上传文件(cv/头像)
    async handleUpload(key, files) {
      const file = files[0]
      const pdfFiles = ['cv']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType,
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB',
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/profile/${this.user.id}/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail,
        })
        return false
      }

      // console.log(file.name)
      // console.log(url)
      // console.log(this.params)

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage(val) {
      window.open(val)
    },

    async submit() {
      const flag = this.$refs['profile-form'].validate()
      if (flag) {
        this.params.keyword = this.params.keywords.join(';')
        await user.complete(this.params)
        this.$message.success({
          title: 'Success',
          content: 'Information completed and saved successfully',
        })
        const res = await user.info()
        res.roles = res.roleList.map((item) => {
          return item.type
        })
        this.updateUser(res)
        if (this.user.roles.includes('REVIEWER')) {
          this.$router.push('/reviewers-menu/reviews')
        } else {
          this.$router.push('/author/submitted-manuscripts')
        }
      }
    },
    cancel() {
      if (this.user.completed) {
        this.$router.back(-1)
      } else {
        this.$router.push('/home')
      }
    },
    cancelCopper() {
      this.isCropper = false
    },
    uploadCropper() {
      this.isCropper = true
    },
    getRules() {
      this.rules = {
        titleCode: [
          {
            required: true,
            message: 'Title' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        affiliation: [
          {
            required: true,
            message: 'Affiliation' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        countryCode: [
          {
            required: true,
            message: 'Country' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        keywords: [
          {
            required: true,
            min: 1,
            message: 'keyword' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
      }
    },
  },
}
